<template>
  <common-dialog ref="dialog" width="600px" show-save-button title="修改备注" @edit-opened="onEditOpened" :data="data"
    :save-func="onSaveFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="买家备注" prop="buyerMemo">
        <el-input v-model="data.buyerMemo" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item label="卖家备注" prop="remark">
        <el-input v-model="data.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      // api: require('@/api/ent/dp').default,
      data: {
        ids: [],
        buyerMemo: "",
        remark: "",
      },
    };
  },
  methods: {
    onEditOpened(data) {
      console.log("data", data);
      // this.data.ids = { ...data }
    },
    onSaveFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
      })
    },
  },
};
</script>
